import moment from 'moment'
import 'moment/locale/en-gb'
import 'moment/locale/de'

moment.locale(window.app.news_list.locale)

export default function install (Vue) {
  Object.defineProperties(Vue.prototype, {
    $moment: {
      get () {
        return moment
      }
    }
  })
}
